export default __webpack_public_path__ + "fonts/edu_2.bcb8b7512da6b381b4976794bc276ec5.png";